(ns splash.ui.lender-portal.state
  "Interop with React state"
  (:require
    ["react" :as react]
    [splash.ui.lender-portal.common.util :as util]
    [splash.ui.lender-portal.config :as config]
    [splash.ui.lender-portal.optimizely :as optimizely]))

(defonce initial-state
  {:loading             false
   :search-inputs       util/initial-search-inputs
   :search-results      nil
   :current-application nil
   :optimizely-client   (optimizely/Optimizely (config/get-config [:optimizely-sdk-key]))})

(def ^:private state-context (react/createContext nil))

(defn with-state
  "Provider that binds state atom to React context for children"
  [state & children]
  (into [:r> (.-Provider state-context) #js {:value state}] children))

(defn use-state
  "Get current state atom from React context"
  []
  (react/useContext state-context))
